import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ImagePlus, X } from "lucide-react";
import { toast } from "sonner";
import { api, fileUrl } from "@/lib/api";
import RecipeForm from "@/components/RecipeForm";

export default function AddRecipe() {
  const navigate = useNavigate();
  const fileRef = useRef();
  const [images, setImages] = useState([]);
  const [saving, setSaving] = useState(false);

  const handleFiles = async (fileList) => {
    for (const f of Array.from(fileList || [])) {
      const fd = new FormData();
      fd.append("file", f);
      try {
        const res = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        setImages((p) => [...p, { path: res.data.path, url: fileUrl(res.data.path) }]);
      } catch { toast.error("Échec envoi photo"); }
    }
  };

  const save = async (payload) => {
    setSaving(true);
    try {
      payload.images = images.map((i) => i.path);
      payload.source = "manual";
      const res = await api.post("/recipes", payload);
      toast.success("Recette créée");
      navigate(`/recipes/${res.data.id}`);
    } catch {
      toast.error("Erreur lors de la création");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="px-5 pt-8" data-testid="add-recipe-page">
      <button onClick={() => navigate(-1)} className="mb-3 flex items-center gap-1 text-sm font-medium at-press" style={{ color: "var(--at-text-2)" }}>
        <ArrowLeft size={16} /> Retour
      </button>
      <h1 className="mb-5 font-display text-2xl font-bold">Nouvelle recette</h1>

      <input ref={fileRef} type="file" accept="image/*" multiple className="hidden" data-testid="add-photo-input" onChange={(e) => handleFiles(e.target.files)} />
      <div className="mb-5">
        <div className="flex gap-3 overflow-x-auto no-scrollbar pb-1">
          <button onClick={() => fileRef.current?.click()} data-testid="add-photo-btn"
            className="flex h-24 w-24 shrink-0 flex-col items-center justify-center gap-1 rounded-2xl border-2 border-dashed at-press"
            style={{ borderColor: "var(--at-border)", color: "var(--at-muted)" }}>
            <ImagePlus size={24} /> <span className="text-xs">Photo</span>
          </button>
          {images.map((img, i) => (
            <div key={i} className="relative h-24 w-24 shrink-0 overflow-hidden rounded-2xl at-shadow" style={{ background: "var(--at-elevated)" }}>
              <img src={img.url} alt="" className="h-full w-full object-contain" />
              <button onClick={() => setImages((p) => p.filter((_, x) => x !== i))} className="absolute right-1 top-1 flex h-6 w-6 items-center justify-center rounded-full bg-black/60 text-white"><X size={13} /></button>
            </div>
          ))}
        </div>
      </div>

      <RecipeForm onSave={save} saving={saving} submitLabel="Créer la recette" />
    </div>
  );
}
